import { render } from "./AdminAddMember.vue?vue&type=template&id=901a0314&scoped=true"
import script from "./AdminAddMember.vue?vue&type=script&lang=js"
export * from "./AdminAddMember.vue?vue&type=script&lang=js"

import "./AdminAddMember.vue?vue&type=style&index=0&id=901a0314&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-901a0314"]])

export default __exports__